import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ListItemText, MenuItem, Typography } from '@mui/material'
import { RouteImage } from '../../../../assets/routeImage'
import { useDispatch, useSelector } from 'react-redux'
import { NavigateFunction, useNavigate } from 'react-router-dom'

// COMPONENT
import Navbar from '../../Navbar'
import Header from '../../Header'
import { ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import * as styled from '../../style/main.style'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import { colors } from '../../../../constants/colors'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'
import ModalCustom from '../../../../component/modal/ModalCustom'
import AddBudget from './add-budget/AddBudget'
import EditBudget from './edit-budget/EditBudget'
import Loading from '../../../../component/loading/Loading'
import FilterSelect from '../../../../component/select/filterSelect'

// API
import { BudgetApi, getBudgets, updateBudget } from '../../../../api/budget/budget.api';

type Props = {}
const BudgetSource: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading)
    const permission = useSelector((state: any) => state?.permission?.permission)

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [budget, setBudget] = useState<any[]>([]);
    const [showModalAdd, setShowModalAdd] = useState<boolean>(false);
    const [showModalEdit, setShowModalEdit] = useState<boolean>(false);
    const [idBudget, setIdBudget] = useState<number>(Number);

    const handleToggleAdd = () => setShowModalAdd(!showModalAdd)
    const handleToggleEdit = () => setShowModalEdit(!showModalEdit)

    const handleChangeStatusBudget = async (idBudget: number, objectData: any, budgetStatus: string) => {
        dispatch(setLoading())
        let condition: updateBudget = {
            budgetName: objectData?.budgetName,
            budgetNo: objectData?.budgetNo,
            budgetStatus: budgetStatus,
            budgetOther: objectData?.budgetOther ? true : false,
        }
        await BudgetApi.updateBudget(idBudget, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetBudget())
    }

    // const handleChangeStatusBudgetOther = async (idBudget: number, objectData: any, budgetOther: boolean) => {
    //     dispatch(setLoading())
    //     let condition: updateBudget = {
    //         budgetName: objectData?.budgetName,
    //         budgetNo: objectData?.budgetNo,
    //         budgetStatus: objectData?.budgetStatus,
    //         budgetOther: budgetOther
    //     }
    //     await BudgetApi.updateBudget(idBudget, condition)
    //         .then(res => {
    //             if (res.status === 200) {
    //                 dispatch(unsetLoading())
    //                 console.log(res.data)
    //             }
    //         })
    //         .catch(error => {
    //             dispatch(unsetLoading())
    //             console.log(error)
    //         })
    //         .finally(() => handleGetBudget())
    // }

    const handleGetBudget = useCallback(async () => {
        dispatch(setLoading())
        let condition: getBudgets = {
            page: page,
            limit: pageLimit
        }
        await BudgetApi.getBudgets(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setTotalItems(res.data?.result?.meta?.totalItems)
                    setBudget(res.data?.result?.items)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit])




    const headCells = [
        {
            id: "RANK", disablePadding: false, align: 'center', width: 80, label: "ลำดับ"

        },
        {
            id: "MISSION", disablePadding: true, align: 'center', width: 700, label: "ภารกิจ"
        },
        {
            id: "STATUS", disablePadding: true, width: 120, align: 'center', label: "สถานะ"
        },
        // {
        //     id: "STATUS_OTHER", width: 200, disablePadding: true, align: 'center', label:
        //         <HeaderTopicTable align='center' text='สถานะเพิ่มเติม' />
        // },
        {
            id: "EDIT", disablePadding: false, align: "left", class: true, width: 100, label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { budgetName, budgetNo, budgetOther, budgetStatus, idBudget } =
            objData;

        const objRenderData = {
            key: idBudget,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center", label: budgetNo,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "TEXT",
                    align: "left", label: budgetName,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "TEXT",
                    align: "left",
                    label:
                        <FilterSelect
                            headingNormal
                            disabled={permission?.find((list: any) => list?.code === "BudgetSource.Edit")?.permit === false}
                            renderValue={() =>
                                <ListItemText className='relative'>
                                    {budgetStatus === t("STATUS.ACTIVE") ? (
                                        <Typography
                                            className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                            {t("STATUS.ACTIVE")}
                                        </Typography>
                                    ) : (
                                        <Typography
                                            className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                            {t("STATUS.INACTIVE")}
                                        </Typography>
                                    )}
                                </ListItemText>
                            }
                            label={t('STATUS.LABEL')}
                            selectId="select-status"
                            value={budgetStatus}
                            labelId="label-status"
                            onchange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                                handleChangeStatusBudget(idBudget, objData, e.target.value)
                            }
                            options={[
                                <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                    <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                                </MenuItem>,
                                <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                    <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                                </MenuItem>
                            ]}
                        />
                    ,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                // {
                //     option: "TEXT",
                //     align: "center",
                //     label:
                //         <FilterSelect
                //             disabled={permission?.find((list: any) => list?.code === "BudgetSource.Edit")?.permit === false}
                //             headingNormal
                //             renderValue={() =>
                //                 <ListItemText className='relative'>
                //                     {budgetOther ? (
                //                         <Typography
                //                             className='text-light_success text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                //                             {t("STATUS.ACTIVE")}
                //                         </Typography>
                //                     ) : (
                //                         <Typography
                //                             className='text-danger text-center after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                //                             {t("STATUS.INACTIVE")}
                //                         </Typography>
                //                     )}
                //                 </ListItemText>
                //             }
                //             label={t('STATUS.LABEL')}
                //             selectId="select-plan-other"
                //             value={budgetOther ? t("STATUS.ACTIVE") : t("STATUS.INACTIVE")}
                //             labelId="label-plan-other"
                //             onchange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                //                 handleChangeStatusBudgetOther(idBudget, objData, e.target.value === t("STATUS.ACTIVE") ? true : false)
                //             }
                //             options={[
                //                 <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                //                     <Typography className='text-light_success'><li>{t("STATUS.ACTIVE")}</li></Typography>
                //                 </MenuItem>,
                //                 <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                //                     <Typography className='text-danger'><li>{t("STATUS.INACTIVE")}</li></Typography>
                //                 </MenuItem>
                //             ]}
                //         />
                //     ,
                //     style: {
                //         backgroundColor: colors.lampang_bg_input_secondary
                //     }
                // },
                {
                    option: "COMPONENT",
                    align: "right",
                    width: 100,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    },
                    class: true,
                    component:
                        <div
                            className='w-full flex justify-end gap-5'>
                            {permission?.find((list: any) => list?.code === "BudgetSource.Edit")?.permit === true && (
                                <Button
                                    onClick={() => {
                                        setIdBudget(idBudget)
                                        handleToggleEdit()
                                    }}
                                    startIcon={<img src={RouteImage.editPen} />}
                                    sx={disableStyleButtonMui}>{"แก้ไข"}</Button>
                            )}
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetBudget()
    }, [page, pageLimit])

    useEffect(() => {
        const permissionCheck = permission?.find((list: any) => list?.code === "BudgetSource.Read")?.permit;
        if (permissionCheck === false) {
            navigate('/404');
        }
    }, [navigate])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            {showModalAdd && (
                <ModalCustom
                    alignHeader='center'
                    maxHeight='auto'
                    enableExit={handleToggleAdd}
                    heading='เพิ่มแหล่งที่มาของงบประมาณ'
                    component={<AddBudget fetchData={handleGetBudget} toggleModal={handleToggleAdd} />}
                />
            )}
            {showModalEdit && (
                <ModalCustom
                    alignHeader='center'
                    maxHeight='auto'
                    enableExit={handleToggleEdit}
                    heading='เพิ่มแหล่งที่มาของงบประมาณ'
                    component={<EditBudget idBudget={idBudget} fetchData={handleGetBudget} toggleModal={handleToggleEdit} />}
                />
            )}
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <section className='flex justify-start items-start md:justify-between flex-col md:flex-row md:items-center gap-3'>
                        <Typography className='text-primary' variant='h4'>
                            แหล่งที่มาของงบประมาณ
                        </Typography>
                        <ButtonOutlined

                            onClick={handleToggleAdd}
                            sx={{
                                maxWidth: "75px",
                                display: permission?.find((list: any) => list?.code === "BudgetSource.Create")?.permit === false ? 'none' : ''
                            }}
                            startIcon={<img src={RouteImage.addButton} />} >
                            <Typography className='text-primary'>{t("BUTTON.ADD")}</Typography>
                        </ButtonOutlined>
                    </section>

                    <section className='mt-8 w-full h-auto'>
                        {budget && (
                            <TableCustom
                                // tableFixedWidth
                                tableMinWidth={1000}
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={budget && budget.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default BudgetSource